import { Box } from "@mui/material";
import { LendingVaultExpanded } from "@bridgesplit/abf-react";
import { TokenSize, getTokenImageSize, TokenImage } from "app/components/common";
import { SPACING, Image } from "@bridgesplit/ui";

export function LendVaultImage({
    lendVaultExpanded,
    size: propsSize,
    offset = -0.25,
    badgeSize = "sm"
}: {
    lendVaultExpanded: LendingVaultExpanded | undefined;
    size: TokenSize;
    badgeSize?: TokenSize;
    offset?: number;
}) {
    const size = getTokenImageSize(propsSize);

    const [primaryToken, secondaryToken] = [
        lendVaultExpanded?.principalMetadata,
        lendVaultExpanded?.vaultMetadata?.managerImage
    ];

    return (
        <Box sx={{ position: "relative", width: size, height: size }}>
            <TokenImage
                size={badgeSize}
                sx={{ position: "absolute", bottom: SPACING * offset, right: SPACING * offset, zIndex: 1 }}
                metadata={primaryToken}
            />
            <Image skeletonVariant="circular" variant="circle" size={size + "px"} src={secondaryToken} />
        </Box>
    );
}
